<template>
  <v-container style="min-height: 100vh; max-width: 100%; padding-top: 0px; padding-bottom: 0px; padding-left: 0px; padding-right: 0px;">
    <iframe
      :src="iframeUrl"
      v-if="isAdmin"
      width="100%"
      height="100%"
      style="border: none"
    ></iframe>
  </v-container>
</template>

<script>
export default {
  name: "UsersReportsCRMReports",
  data() {
    return {
      iframeUrl: process.env.VUE_APP_SUPERSET_USERS_REPORT,
      isAdmin: false,
    };
  },
  created() {
    this.userRoles = JSON.parse(localStorage.getItem("userRoles"));
    if (
      this.userRoles.find((x) => x == "PanelUser") != null &&
      this.userRoles.find((x) => x == "PanelUser") != undefined
    ) {
      this.isAdmin = true;
    }
  },
};
</script>

<style scoped>
  .container {
    padding: 0 !important;
  }
</style>
